const FB_ERRORS = {
	FUNCTIONS_NOT_FOUND: 'functions/not-found',
	FUNCTIONS_RESOURCE_EXHAUSTED: 'functions/resource-exhausted',
	FUNCTIONS_ALREADY_EXISTS: 'functions/already-exists',
	FUNCTIONS_FAILED_PRECONDITION: 'functions/failed-precondition',
	FUNCTIONS_PERMISSION_DENIED: 'functions/permission-denied',
}

export default FB_ERRORS
